import React, { useState, useEffect } from 'react';
import { Form, Card, Modal } from "react-bootstrap";
import close from '../Asset/close.svg';
import { Link } from 'react-router-dom';
import Alert from './Alert';
import { getUserInfo, getPlainText } from './functions/userInfo';
import SessionFun from './functions/sessionFun';
import { environment } from './functions/environment';

function Profile() {
    let userObj = getUserInfo();
    userObj.emailID = getPlainText(userObj.emailID);
    userObj.PhoneNumber = getPlainText(userObj.PhoneNumber);

    let fname = (userObj.firstName).toLowerCase();
    let lname = (userObj.lastName).toLowerCase();
    let [sessOut, setSessOut] = useState(false);
    let [UserInfo, setUserInfo] = useState({
        roleName: "",
        firstName: "",
        lastName: "",
        emailID: "",
        PhoneNumber: "",
        regionName: "",
        accountName: "",
        siteName: ""
    });

    let [alert, setAlert] = useState({
        msg: "",
        status: false
    });
    let [forgotPassword, setForgotPassword] = useState({
        password: "",
        newPassword: "",
        confirmPassword: ""
    });

    //     console.log("decretio enail:",testAes());
    //   function testAes(){
    //     var bytes = CryptoJS.AES.decrypt(userObj.emailID.encryptedData, 'a1b2c3d4e5f6g7h8i9j0k1l2m3n4o5p6');
    //     let userObj = bytes.toString(CryptoJS.enc.Utf8);
    //     return (JSON.parse(userObj));
    //   }
    useEffect(() => {
        if (sessionStorage.getItem('userInfo')) {
            setUserInfo(userObj);
        }
        else {
            setUserInfo = {
                roleName: "",
                firstName: "",
                lastName: "",
                emailID: "",
                PhoneNumber: "",
                regionName: "",
                accountName: "",
                siteName: ""
            }
        }
    }, [])
    const [show, setShow] = useState(false);

    const handleClose = (type) => {
        if (type == "close") {
            setShow(false);
        }
        setForgotPassword({
            password: "",
            newPassword: "",
            confirmPassword: ""
        });
        setErrorMsg({});
    }
    const handleShow = () => {
        setShow(true);
    }
    function getPasswordData(e) {
        setForgotPassword({ ...forgotPassword, [e.target.name]: e.target.value });
    }

    let [errorMsg, setErrorMsg] = useState({});
    function validate() {
        let error = {};

        if (forgotPassword.password == "") {
            error.password = "This field is required";
        }

        if (forgotPassword.newPassword == "") {
            error.newPassword = "This field is required";
        }
        else if (forgotPassword.newPassword.length < 10 || forgotPassword.newPassword.length > 16) {
            error.newPassword = "Password should be minimum 10 characters or maximum 16 characters";
        }
        else if (/\s/g.test(forgotPassword.newPassword)) {
            error.newPassword = "Password should not contain space";
        }
        else if (forgotPassword.newPassword.search(/(?=.*[0-9])/)) {
            error.newPassword = "Password must have at least one digit";
        }
        else if (forgotPassword.newPassword.search(/(?=.*[A-Z])/)) {
            error.newPassword = "Password must have at least one capital letter";
        }
        else if (forgotPassword.newPassword.search(/(?=.*[a-z])/)) {
            error.newPassword = "Password must have at least one small letter";
        }
        else if (forgotPassword.newPassword.search(/(?=.*[!@%^?~_:?\]\[.{}-])/)) {
            error.newPassword = "Password must have at least one special character (~ ! @ % ^ _ - : ? . {} [])";
        }
        else if ((forgotPassword.newPassword.toLowerCase()).includes(fname) || (forgotPassword.newPassword.toLowerCase()).includes(lname)) {
            error.newPassword = "First Name and Last Name cannot be used as a Password";
        }
        else if ((forgotPassword.newPassword.toLowerCase()).includes("godrej") || (forgotPassword.newPassword.toLowerCase()).includes("jerdog")) {
            error.newPassword = '"GODREJ" and "JERDOG" cannot be used as a Password';
        }
        else if (checkSequence(forgotPassword.newPassword)) {
            error.newPassword = "3 or more consecutive digits. e.g. 123, 321 cannot be used in the Password";
        }
        else if (forgotPassword.password === forgotPassword.newPassword) {
            error.newPassword = "Please enter different password. Old password and new password are same";
        }
        if (forgotPassword.confirmPassword == "") {
            error.confirmPassword = "This field is required";
        }
        else if (forgotPassword.confirmPassword.length < 8) {
            error.confirmPassword = "Password must be atleast 8 characters";
        }
        else if (forgotPassword.newPassword != forgotPassword.confirmPassword) {
            error.confirmPassword = "Confirm password is not match with new password";
        }

        setErrorMsg(error);

        if (Object.keys(error).length == 0) {
            changePassword();
        }
        else {
            //console.log(error);
        }
    }
    function checkSequence(pass) {
        let isSeq = false;
        for (let i = 0; i < pass.length; i++) {
            if (i + 2 < pass.length && !isNaN(pass[i]) && !isNaN(pass[i + 1]) && !isNaN(pass[i + 2])) {
                let diff1 = Math.abs(parseInt(pass[i] - pass[i + 1]));
                let diff2 = Math.abs(parseInt(pass[i + 1] - pass[i + 2]));

                if (diff1 == 1 && diff2 == 1) {
                    isSeq = true;
                    //console.log(pass[i], i);
                    break;
                }
            }
        }
        return isSeq;
    }
    function changePassword() {
        fetch(environment.baseUrl + 'changePassword', {
            method: "PUT",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + userObj.token
            },
            body: JSON.stringify(forgotPassword)
        }).then((result) => {
            result.json().then((res) => {
                // console.log("Final Password", res);
                setAlert({
                    msg: res.msg,
                    status: true
                })
                handleClose("close");
            })
        })
    }

    return (
        <div className='main-container'>
            <SessionFun show={sessOut}></SessionFun>
            <Alert obj={alert} />
            <h4 className='main-heading'>My Profile</h4>
            <p className='short-link'><Link to='/'>Home&nbsp;<i className='fa fa-angle-right'></i></Link>&nbsp; My Profile</p>

            <Card>
                <Card.Body>
                    {/* Row 2 */}
                    {
                        UserInfo.userType == "technician_user" ?
                            <div>
                                <div className="row mt-1">
                                    <div className="col-sm-4">
                                        <Form.Group className="mb-3" >
                                            <Form.Label>Region</Form.Label>
                                            <Form.Control readOnly type="text" value={UserInfo.regionName !== null ? UserInfo.regionName : "NA"} className="textbox-back" />
                                        </Form.Group>
                                    </div>
                                    <div className="col-sm-4">
                                        <Form.Group className="mb-3" >
                                            <Form.Label>First Name</Form.Label>
                                            <Form.Control readOnly type="text" value={UserInfo.firstName !== null ? UserInfo.firstName : "NA"} className="textbox-back" />
                                        </Form.Group>
                                    </div>
                                    <div className="col-sm-4">
                                        <Form.Group className="mb-3" >
                                            <Form.Label>Last Name</Form.Label>
                                            <Form.Control readOnly type="text" value={UserInfo.lastName !== null ? UserInfo.lastName : "NA"} className="textbox-back" />
                                        </Form.Group>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-sm-4">
                                        <Form.Group className="mb-3" >
                                            <Form.Label>Email ID</Form.Label>
                                            <Form.Control readOnly type="text" value={UserInfo.emailID !== null ? UserInfo.emailID : "NA"} className="textbox-back" />
                                        </Form.Group>
                                    </div>
                                    <div className="col-sm-4">
                                        <Form.Group className="mb-3" >
                                            <Form.Label>Mobile Number</Form.Label>
                                            <Form.Control readOnly type="text" value={UserInfo.PhoneNumber !== null ? UserInfo.PhoneNumber : "NA"} className="textbox-back" />
                                        </Form.Group>
                                    </div>
                                </div>

                            </div>
                            :
                            <div>
                                <div className="row">
                                    <div className="col-sm-4">
                                        <Form.Group className="mb-3" >
                                            <Form.Label>Role</Form.Label>
                                            <Form.Control readOnly type="text" value={UserInfo.roleName !== null ? UserInfo.roleName : "NA"} className="textbox-back" />
                                        </Form.Group>
                                    </div>
                                    {
                                        UserInfo.userType == "admin" ? null :
                                            <>
                                                <div className="col-sm-4">
                                                    <Form.Group className="mb-3" >
                                                        <Form.Label>Account Name</Form.Label>
                                                        <Form.Control readOnly type="text" value={UserInfo.accountName !== null ? UserInfo.accountName : "NA"} className="textbox-back" />
                                                    </Form.Group>
                                                </div>
                                                <div className="col-sm-4">
                                                    <Form.Group className="mb-3" >
                                                        <Form.Label>Site</Form.Label>
                                                        <Form.Control readOnly type="text" value={UserInfo.siteName !== null ? UserInfo.siteName : "NA"} className="textbox-back" />
                                                    </Form.Group>
                                                </div>
                                            </>
                                    }

                                    <div className="col-sm-4">
                                        <Form.Group className="mb-3" >
                                            <Form.Label>First Name</Form.Label>
                                            <Form.Control readOnly type="text" value={UserInfo.firstName !== null ? UserInfo.firstName : "NA"} className="textbox-back" />
                                        </Form.Group>
                                    </div>
                                    <div className="col-sm-4">
                                        <Form.Group className="mb-3" >
                                            <Form.Label>Last Name</Form.Label>
                                            <Form.Control readOnly type="text" value={UserInfo.lastName !== null ? UserInfo.lastName : "NA"} className="textbox-back" />
                                        </Form.Group>
                                    </div>
                                    <div className="col-sm-4">
                                        <Form.Group className="mb-3" >
                                            <Form.Label>Email ID</Form.Label>
                                            <Form.Control readOnly type="text" value={UserInfo.emailID !== null ? UserInfo.emailID : "NA"} className="textbox-back" />
                                        </Form.Group>
                                    </div>

                                    <div className="col-sm-4">
                                        <Form.Group className="mb-3" >
                                            <Form.Label>Mobile Number</Form.Label>
                                            <Form.Control readOnly type="text" value={UserInfo.PhoneNumber !== null ? UserInfo.PhoneNumber : "NA"} className="textbox-back" />
                                        </Form.Group>
                                    </div>
                                </div>
                            </div>
                    }
                    <div className="col-sm-4">

                    </div>
                    <div className="row justify-content-end d-none">
                        <button onClick={handleShow} className='btn btn-primary btn-save2 ml-4'>Change Password</button>
                    </div>
                </Card.Body>
            </Card>

            <div className="row mt-3">
                <div className="col-sm-4 left-col">
                </div>
                <div className="col-sm-8  mt-4">
                    {/* <button className="btn btn-save float-right mt-2 ml-4">
                        Save
                    </button>
                    <button className="btn btn-cancel float-right mt-2" >Cancel</button> */}
                </div>
            </div>

            {/* //////////Pop Up Screen////////// */}
            <Modal show={show} onHide={() => handleClose("close")} centered backdrop="static" size="lg">
                <Modal.Header>
                    <Modal.Title>Change Password</Modal.Title>
                    <button onClick={() => handleClose("close")} type="button" className="close">
                        <img src={close} alt="" />
                    </button>
                </Modal.Header>
                <Modal.Body className=' logout-box'>
                    <div className="row">
                        <div className="col-sm-4">
                            <Form.Group className="mb-3" >
                                <Form.Label>Old Password</Form.Label>
                                <Form.Control className="textbox-back" name='password' type="password"
                                    placeholder="Enter Old Password"
                                    value={forgotPassword.password}
                                    onChange={getPasswordData}
                                />
                                <small className='red'>{errorMsg.password}</small>
                            </Form.Group>
                        </div>
                        <div className="col-sm-4">
                            <Form.Group className="mb-3" >
                                <Form.Label>New Password</Form.Label>
                                <Form.Control className="textbox-back" name='newPassword' type="password"
                                    placeholder="Enter New Password"
                                    value={forgotPassword.newPassword}
                                    onChange={getPasswordData}
                                />
                                <small className='red'>{errorMsg.newPassword}</small><br />
                            </Form.Group>
                        </div>
                        <div className="col-sm-4">
                            <Form.Group className="mb-3" >
                                <Form.Label>Confirm Password</Form.Label>
                                <Form.Control className="textbox-back" name='confirmPassword' type="password"
                                    placeholder="Confirm New Password"
                                    value={forgotPassword.confirmPassword}
                                    onChange={getPasswordData}
                                />
                                <small className='red'>{errorMsg.confirmPassword}</small>
                            </Form.Group>
                        </div>
                    </div>

                    <div className=" float-end">
                        <button type='cancel' className="btn btn-outline-secondary me-3" onClick={handleClose}>
                            Clear
                        </button>
                        <button type='submit' className="btn btn-light confirm-btn me-3" onClick={validate}>
                            Change Password
                        </button>
                    </div>



                </Modal.Body>
            </Modal>
        </div >
    )
}

export default Profile

